"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const ImageWidget_1 = tslib_1.__importStar(require("./ImageWidget"));
class StatusBarWidget extends fmko_ts_common_1.Widget {
    constructor(args) {
        super();
        const { label, textContent, editCallback, placeholder } = args;
        this.element = document.createElement("div");
        this.element.classList.add("status-bar-widget", "flex-col");
        this.label = document.createElement("small");
        this.setLabel(label);
        this.label.classList.add("status-bar-widget-header");
        this.add(this.label);
        this.placeholder = placeholder ?? "-";
        this.body = document.createElement("div");
        this.body.classList.add("flex-row", "half-rem-margin-right");
        this.add(this.body);
        this.textContentElement = document.createElement("span");
        this.textContentElement.className = "status-bar-body-text";
        this.setTextContent(textContent);
        this.body.appendChild(this.textContentElement);
        this.editCallback = editCallback;
        this.editIcon = new ImageWidget_1.default({
            alt: "Rediger",
            imageDimension: ImageWidget_1.ImageDimensions.XL,
            src: fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.EDIT)
        });
        this.editIcon.element.classList.add("grey-background-color");
        fmko_ts_common_1.WCAG.addButtonEvent({
            callback: () => this.editCallback?.(),
            element: this.editIcon.element
        });
        (0, fmko_ts_common_1.setElementVisible)(this.editIcon.element, !!this.editCallback);
        this.body.appendChild(this.editIcon.element);
    }
    setLabel(label) {
        this.label.innerHTML = fmko_ts_common_1.HTMLUtils.sanitizeHTML(label);
    }
    setTextContent(textContent) {
        this.textContentElement.innerText = textContent ?? this.placeholder;
    }
    setPlaceholder(placeholder) {
        this.placeholder = placeholder;
    }
    setEditCallback(cb) {
        (0, fmko_ts_common_1.setElementVisible)(this.editIcon.element, !!cb);
        this.editCallback = cb;
    }
    wipe() {
        this.label.innerHTML = "";
        this.textContentElement.innerHTML = "";
        (0, fmko_ts_common_1.setElementVisible)(this.editIcon.element, false);
        this.editCallback = undefined;
    }
}
exports.default = StatusBarWidget;
//# sourceMappingURL=StatusBarWidget.js.map